import { PropsWithChildren } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import Assessment from "@apps/assessments/components/assessment/assessment";
import useLabel from "@apps/use-label/use-label";
import { isAdminVar } from "@cache/cache";
import Button from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";
import Layout from "@components/layout/layout";
import useDocumentTitle from "@components/use-document-title/use-document-title";

import AssessmentDeliveryPage from "./components/delivery/assessment-delivery-page";
import AssessmentsHomepage from "./components/homepage";

const AssessmentsNavContainer = (
  props: PropsWithChildren & { showNav?: boolean },
) => {
  const label = useLabel();
  const isAdmin = isAdminVar();
  return (
    <Layout>
      <Layout.Header
        breadcrumbs={[
          {
            title: label("review", { capitalize: true, pluralize: true }),
            url: "/assessments",
          },
        ]}
      >
        {isAdmin && (
          <div className="flex justify-end gap-4 items-center">
            <Button
              text={`Create ${label("review")} program`}
              to="/programs/new"
              theme={buttonTheme.primary}
            />
          </div>
        )}
      </Layout.Header>
      <Layout.Container>
        {props.showNav ? (
          <Layout.Main width="full">
            <Layout.MainSection>{props.children}</Layout.MainSection>
          </Layout.Main>
        ) : (
          props.children
        )}
      </Layout.Container>
    </Layout>
  );
};

const Assessments = () => {
  const label = useLabel();
  useDocumentTitle(label("review", { capitalize: true, pluralize: true }));
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route
        exact
        path={[
          `${path}/home`,
          `${path}/active`,
          `${path}/delivered`,
          `${path}`,
        ]}
      >
        <AssessmentsNavContainer>
          <AssessmentsHomepage />
        </AssessmentsNavContainer>
      </Route>

      <Route exact path={`${path}/assessment/:assessmentId(\\d+)`}>
        <Assessment />
      </Route>
      <Route
        exact
        path={`${path}/assessment/delivery/:assessmentDeliveryId(\\d+)`}
      >
        <AssessmentDeliveryPage />
      </Route>
    </Switch>
  );
};

export default Assessments;
